import React, {useMemo} from 'react';
import {style, classes} from './doppe-viewer-rich-text-view.st.css';
import {OmitStrict, PartiallyOptional, PickKeys, Values} from "@wix/devzai-utils-common";
import {RichTextView} from "@wix/devzai-utils-react";
import {
    DoppeRichTextContentType,
    doppeRichTextContentTypeResolveTipTapExtensions
} from "../../client-server-common/doppe-tiptap-extensions/doppe-tiptap-extensions";

export const DoppeViewerRichTextViewHtmlRenderingMode = {
    FullRichText: 'fullRichText',
    PlainText: 'plainText',
} as const;

export type DoppeViewerRichTextViewHtmlRenderingMode = Values<typeof DoppeViewerRichTextViewHtmlRenderingMode>;

export const DoppeViewerRichTextView = React.memo(function DoppeViewerRichTextView (props: DoppeViewerRichTextView.Props) {
    const {
        htmlRenderingMode,
        richTextContentType,

        className,
        ...restProps
    } = props;

    const extensions = useMemo(() => {
        return doppeRichTextContentTypeResolveTipTapExtensions(richTextContentType);
    }, [richTextContentType])

    return (
        <RichTextView
            {...restProps}
            className={style(classes.root, {htmlRenderingMode: htmlRenderingMode}, className)}
            removeMarkingStyle={htmlRenderingMode === DoppeViewerRichTextViewHtmlRenderingMode.PlainText}
            extensions={extensions}
        />
    );
});

export namespace DoppeViewerRichTextView {

    type OmittedProps = PickKeys<RichTextView.Props, 'extensions'>;
    type PropsWithDefaultValues = PickKeys<RichTextView.Props, never>

    export interface Props extends PartiallyOptional<OmitStrict<RichTextView.Props, OmittedProps>, PropsWithDefaultValues> {
        htmlRenderingMode: DoppeViewerRichTextViewHtmlRenderingMode;
        richTextContentType: DoppeRichTextContentType;
    }
}